const DUNE_GAME_ID = 'e76337e746e1f95fdbf7e23c26010e448';
const CONAN_GAME_ID = 'efc7a5eee1d6ca668931bcebf69198b60';

export interface IVersionConfigLevel {
  value: string;
  label: string;
}

export interface IVersionConfig {
  levels: IVersionConfigLevel[];
  /** API 返回的版本树字段名，默认 'version_tree' */
  treeKey?: string;
  /** 筛选参数 key 映射，默认 { chapters: 'chapters', releases: 'releases' } */
  version_filters?: boolean;
  /** 是否隐藏 Update Title 多选筛选器（如 Conan 使用 version_filters 模式，不需要 title 筛选） */
  hideTitleFilter?: boolean;
  /** Timeline 图表 series 唯一 key 组合字段（用 '__' 拼接），解决同 chapter 跨 season 重复问题 */
  uniqueKeyFields?: string[];
}

export const VersionAnalysisConfig: Record<string, IVersionConfig> = {
  [DUNE_GAME_ID]: {
    levels: [
      { value: 'chapter', label: 'Chapter' },
      { value: 'release', label: 'Release-1' },
    ],
    hideTitleFilter: true,
  },
  [CONAN_GAME_ID]: {
    levels: [
      { value: 'season', label: 'Season' },
      { value: 'chapter', label: 'Chapter' },
    ],
    treeKey: 'season_tree',
    version_filters: true,
    hideTitleFilter: true,
    uniqueKeyFields: ['season', 'chapter'],
  },
};

/** 根据游戏 ID 获取版本分析配置，无配置时返回 null */
export const getVersionConfig = (gameId?: string): IVersionConfig | null => {
  if (!gameId || !VersionAnalysisConfig[gameId]) return null;
  return VersionAnalysisConfig[gameId];
};
